"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restrictionsSections = void 0;
exports.restrictionsSections = ['conversion', 'precalc', 'overall'];
